import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { WiMuleSQL } from "../../services/WiMuleSQL";

const fetchIN12aHBWAmbient = async () => {
  const response = await axios.get(`${WiMuleSQL}/api/BWOS/GetIN12aHBWAmbient`);

  return response.data.data;
};

export const useIN12aHBWAmbient = (enabled = true) =>
  useQuery({
    queryKey: ["IN12aHBWAmbient"],
    queryFn: () => fetchIN12aHBWAmbient(),
    enabled,
    staleTime: 60 * 1000, // 1 min if focused
    refetchInterval: 120 * 1000, // ← auto-update every 2 minute
  });
